<header class="app2 loding-header nav-abs custom-scroll">
  <div class="animated-bg"><i></i><i></i><i></i></div>
  <div class="container">
    <div class="row ">
      <div class="col">
        <nav class="">
          @defer(when logoText){
          @switch(screenSize$ | async){
          @case ('xsmall') {
          <a [routerLink]="['/']" fragment="home" class="d-inline-block m-r-auto">
            <img [src]="logoText" width="120rem" height="60rem" alt="logo Fit Up" class="">
          </a>
          }@case ('small') {
          <a [routerLink]="['/']" fragment="home" class="d-inline-block m-r-auto">
            <img [src]="logoText" width="140rem" height="65rem" alt="logo Fit Up" class="">
          </a>
          }@default {
          <a [routerLink]="['/']" fragment="home" class="d-inline-block m-r-auto pt-4">
            <img [src]="logoText" width="180rem" height="90rem" alt="logo Fit Up" class="">
          </a>
          }
          }
          }@placeholder {
          @switch (screenSize$ | async) {
          @case ('xsmall') {
          <!-- Conteúdo para telas muito pequenas -->
          <a href="#" class="d-inline-block m-r-auto">
            <ngx-skeleton-loader [appearance]="'line'" animation="pulse"
              [theme]="{width:'5rem', height:'3.125rem', marginTop:'1rem'}"></ngx-skeleton-loader>
          </a>
          }@default{
          <!-- Conteúdo para demais -->
          <a href="#" class="d-inline-block m-r-auto">
            <ngx-skeleton-loader [appearance]="'line'" animation="pulse"
              [theme]="{width:'8rem', height:'3.125rem', marginTop:'1rem'}"></ngx-skeleton-loader>
          </a>
          }
          }
          }
          <app-menu></app-menu>
        </nav>
      </div>
    </div>
  </div>
</header>